<template lang="pug">
#member_edit
  .container
    breadcrumb(v-bind:pageName="pageName")
    p.action_btns
      |
      span.member_center_btn(@click="toMemberCenter") 會員訂單
      | |
      span.logout_btn(@click="toLogout") 登出
  .container.pb-5
    h5.text-center.text-md-left 會員資料
    form.member_info.mt-3(:class="{ editable: isEditable }")
      .row.flex-md-row-reverse
        .col-12.col-md-6.text-right
          .edit_btn(@click="editMemberInfo")
        .col-12.col-md-6.mt-3.mt-md-0
          .email Hi,
            span {{ userInfo.email }}
      .row.mt-3
        .col-md-6
          span.title 姓名
          input.form-control(
            type="text",
            placeholder="尚未填寫",
            v-model="userInfo.name"
          )
        .col-md-6
          span.title 電話
          input.form-control(
            type="text",
            placeholder="尚未填寫",
            v-model="userInfo.phone"
          )
        .col-md-6.mt-3
          span.title 地址
          input.form-control(
            type="text",
            placeholder="尚未填寫",
            v-model="userInfo.address"
          )
        .col-md-6.mt-3
          span.title 身分證字號
          input.form-control(
            type="text",
            placeholder="尚未填寫",
            v-model="userInfo.citizen_id"
          )
  .container.pb-5
    h5.text-center.text-md-left 常用報名資訊
    .action_btns_add
      p
        |
        span.add_btn(@click="addGeneral") + 新增
        | /
        span.save_btn(@click="updateGeneralList") 儲存
    hr
    .common_info.mb-4.border-radius-10.mb-5.mt-3(
      v-for="(general, index) in userInfoForGeneral.apply_targets"
    )
      .delete_btn(@click="deleteGeneral(index)") - 移除
      .row
        .col-md-6.left
          span.title 學生姓名
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入學生姓名",
            v-model="userInfoForGeneral.apply_targets[index].name"
          )
          span.title 聯絡人電話
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入您的聯絡電話",
            v-model="userInfoForGeneral.apply_targets[index].parent_phone"
          )
          span.title 就讀學校
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入學生就讀學校",
            v-model="userInfoForGeneral.apply_targets[index].school"
          )
          span.title 就讀年級
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入學生年級",
            v-model="userInfoForGeneral.apply_targets[index].grade"
          )
          span.title 出生年月日(保險用) ex:2000/01/01
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入學生出生年月日",
            v-model="userInfoForGeneral.apply_targets[index].birthday"
          )
          span.title 身份證字號(保險用)
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入學生身分證字號",
            v-model="userInfoForGeneral.apply_targets[index].citizen_id"
          )
        .col-md-6.right
          span.title 法定代理人姓名(保險用)
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入法定代理人姓名",
            v-model="userInfoForGeneral.apply_targets[index].legal_representative_name"
          )
          span.title 法定代理人出生年月日(保險用)
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入法定代理人出生年月日",
            v-model="userInfoForGeneral.apply_targets[index].legal_representative_birthday"
          )
          span.title 法定代理人身分證字號(保險用)
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入法定代理人身分證字號",
            v-model="userInfoForGeneral.apply_targets[index].legal_representative_citizen_id"
          )
          span.title 籃球學習經驗描述（參加過社團或其他籃球營隊）
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入學生的籃球學習經驗描述",
            v-model="userInfoForGeneral.apply_targets[index].basketball_experience"
          )
          span.title 課程主要目標
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入課程主要目標",
            v-model="userInfoForGeneral.apply_targets[index].basketball_goal"
          )
      hr.mt-5
      .row
        .col-12
          span.title 聯絡人LINE帳號ID
          span.mt-1 (請務必打開ID並留下您的ID，會有專人向您確認報名資訊，如沒有打開ID視同放棄報名及優惠)
          input.form-control(
            required="true",
            type="text",
            placeholder="請輸入 LINE 帳號 ID",
            v-model="userInfoForGeneral.apply_targets[index].parent_line_id"
          )

          span.title 健康狀況
          .radio_btn.mt-2.flex_h
            input(
              type="radio",
              name="healh",
              value="遺傳疾病",
              v-model="userInfoForGeneral.apply_targets[index].health_condition"
            )
            span 遺傳疾病
          .radio_btn.flex_h
            input(
              type="radio",
              name="healh",
              value="心臟疾病",
              v-model="userInfoForGeneral.apply_targets[index].health_condition"
            ) 
            span 心臟疾病
          .radio_btn.flex_h
            input(
              type="radio",
              name="healh",
              value="氣喘",
              v-model="userInfoForGeneral.apply_targets[index].health_condition"
            ) 
            span 氣喘
          .radio_btn.flex_h
            input(
              type="radio",
              name="healh",
              value="癲癇",
              v-model="userInfoForGeneral.apply_targets[index].health_condition"
            ) 
            span 癲癇
          .radio_btn.flex_h
            input(
              type="radio",
              name="healh",
              value="無",
              v-model="userInfoForGeneral.apply_targets[index].health_condition"
            ) 
            span 無

          span.title 食物過敏(小朋友不能吃的及吃了會過敏的請註明)
          input.form-control(
            required="true",
            type="text",
            v-model="userInfoForGeneral.apply_targets[index].food_allergens"
          )
    .action_btns_bottom.text-center(
      v-if="userInfoForGeneral.apply_targets && userInfoForGeneral.apply_targets.length > 0"
    )
      p
        |
        span.add_btn(@click="addGeneral") + 新增
        | /
        span.save_btn(@click="updateGeneralList") 儲存
  dialog-success(
    v-if="successDialogShow",
    :title="successDialogTitle",
    :content="successDialogContent"
  )
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { mapActions } from "vuex";
import { getUserInfo, updateUserInfo } from "@/api/user";
import DialogSuccess from "@/components/login/DialogSuccess";
import DialogLoading from "@/components/dialog/DialogLoading";
import { errorMessage } from "@/utils/message";

export default {
  name: "MemberCenter",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    "dialog-success": DialogSuccess,
    "dialog-loading": DialogLoading,
  },
  data() {
    return {
      pageName: "編輯會員資料",
      isEditable: false,
      userInfo: {},
      userInfoForGeneral: {},
      successDialogShow: false,
      successDialogTitle: "",
      successDialogContent: "",
      loadingDialogShow: false,
      loadingContent: "修改中....",
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    ...mapActions("user", ["logout"]),
    toLogout() {
      this.logout();
      this.$router.push({ name: "Home" });
    },
    toMemberCenter() {
      this.$router.push({ name: "MemberCenter" });
    },
    editMemberInfo() {
      if (this.isEditable) {
        this.updateUserInfo();
        this.isEditable = false;
      } else {
        this.isEditable = true;
      }
    },
    getUserInfo() {
      getUserInfo().then((response) => {
        this.userInfo = response.data;
        this.userInfoForGeneral = Object.assign({}, this.userInfo);
      });
    },
    updateUserInfo() {
      this.loadingDialogShow = true;
      updateUserInfo(this.userInfo)
        .then(() => {
          this.getUserInfo();
          this.loadingDialogShow = false;
          this.successDialogShow = true;
          this.successDialogTitle = "修改成功";
          this.successDialogContent = "會員資料已修改";
          setTimeout(() => {
            this.successDialogShow = false;
            this.successDialogTitle = "";
            this.successDialogContent = "";
          }, 1500);
        })
        .catch((error) => {
          this.loadingDialogShow = false;
          errorMessage(this, "修改失敗", error.response.data.error_msg);
        });
    },
    updateGeneralList() {
      this.loadingDialogShow = true;
      updateUserInfo(this.userInfoForGeneral)
        .then(() => {
          this.getUserInfo();
          this.loadingDialogShow = false;
          this.successDialogShow = true;
          this.successDialogTitle = "修改成功";
          this.successDialogContent = "常用聯絡人已修改";
          setTimeout(() => {
            this.successDialogShow = false;
            this.successDialogTitle = "";
            this.successDialogContent = "";
          }, 1500);
        })
        .catch((error) => {
          this.loadingDialogShow = false;
          errorMessage(this, "修改失敗", error.response.data.error_msg);
        });
    },
    addGeneral() {
      if (this.userInfoForGeneral.apply_targets.length >= 10) {
        errorMessage(this, "警告", "常用報名資訊最多只能10筆");
      } else {
        let temp = {
          email: "",
          name: "",
          citizen_id: "",
          parent_phone: "",
          parent_line_id: "",
          birthday: "",
          legal_representative_name: "",
          legal_representative_birthday: "",
          legal_representative_citizen_id: "",
          basketball_goal: "",
          school_name: "",
          grade: "",
          basketball_experience: "",
          health_condition: "",
          food_allergens: "",
        };
        this.userInfoForGeneral.apply_targets.push(temp);
      }
    },
    deleteGeneral(index) {
      this.userInfoForGeneral.apply_targets.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/common/input.scss";
@import "@/assets/style/common/action.btns";

.member_info {
  padding: 30px;
  border-radius: 10px;
  border: 1px solid #b9bdc7;
  transition: all 0.5s ease-in;

  input[type="text"] {
    pointer-events: none;
    color: #212529;
    border-color: #fff;
    transition: all 0.5s ease-in;
  }

  .email {
    color: $c-text;
    font-size: 14px;
    font-weight: 600;

    span {
      margin-left: 5px;
      text-decoration-color: $c-text;
      text-decoration: underline;
      word-break: break-word;
    }
  }

  .edit_btn {
    display: inline-block;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    margin-right: 15px;
    color: $color_water_blue;

    &::after {
      content: "編輯會員資料";
    }
  }
}

.member_info.editable {
  border-color: $color_blue;
  box-shadow: 0px 0px 26px rgba($color_blue, 0.1);

  input[type="text"] {
    color: $c-text;
    border-color: $c-text;
    pointer-events: auto;
  }

  .edit_btn {
    &::after {
      content: "完成編輯";
    }
  }
}

#member_edit {
  position: relative;
  height: auto;
  position: relative;
}

h5 {
  color: $c-text;

  span {
    font-size: 14px;
  }
}

.container {
  position: relative;
}

.action_btns {
  position: absolute;
  top: 45px;
  right: 15px;
  font-weight: 500;
  font-weight: 20px;
  color: #6d7278;

  .member_info_btn {
    cursor: pointer;
    color: #6d7278;
    margin-right: 10px;
  }
}

.common_info {
  padding: 30px;
  border-radius: 10px;
  border: 1px solid #b9bdc7;

  .left {
    border-right: 1px solid #e8e8e8;
    padding-right: 20px;
  }

  .right {
    padding-left: 20px;
  }
}

.container {
  position: relative;
}

input[type="text"] {
  margin-top: 10px;
  border-color: #707070;
  color: $c-text;
  height: 50px;
}

input[type="radio"] {
  margin-right: 5px;
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-top: 0;
}

.radio_btn {
  align-items: center;
  line-height: 40px;

  span {
    line-height: 40px;
  }
}

.title {
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: $c-text;
  margin-top: 20px;
}

.title.unrequire {
  &::after {
    content: "";
  }
}

::placeholder {
  color: #aaaaaa;
}

.group {
  display: inline-flex;
  flex-wrap: wrap;
  background-color: #f4f4f4;
  border-radius: 5px;
  margin-top: 10px;

  .radio_btn {
    margin-right: 15px;
  }
}

input[type="checkbox"] {
  width: 20px;
  height: 20px;
}

.checkbox {
  span {
    margin-left: 5px;
  }
}

.selector {
  display: flex;
}

select {
  width: auto;
  margin-right: 15px;
  flex-grow: 2;
  box-shadow: none;
}

.action_btns_add,
.action_btns_bottom {
  color: #5a5a5a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  span {
    font-size: 18px;
  }
  span.add_btn {
    color: #989ea5;
    margin-right: 10px;
  }

  span.save_btn {
    margin-left: 10px;
  }

  span.add_btn,
  span.save_btn {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
}

.action_btns_add {
  position: absolute;
  top: 0;
  right: 15px;
  font-weight: 500;
  font-weight: 20px;
}

.delete_btn {
  background-color: $color_red;
  color: white;
  display: inline-block;
  font-size: 16px;
  padding: 8px;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
}

@media (max-width: 767px) {
  .breadcrumb-container {
    margin-bottom: 0.5rem;
  }

  .action_btns {
    position: relative;
    top: initial;
    right: initial;
  }

  .action_btns_add {
    position: relative;
    top: initial;
    right: initial;
  }

  .common_info {
    .left {
      border-right: 0px solid #e8e8e8;
    }

    .right {
      padding-left: 15px;
    }
  }

  .title {
    margin-top: 20px;
  }

  input[type="text"] {
    width: 100%;
  }
  .selector {
    flex-direction: column;
  }
}
</style>
